import React, { useState } from 'react';
import { Shield, Mail, RefreshCw } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EmailVerificationGate({ children }) {
  const { user, logout } = useAuth();
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  // Admins and users with email_verified (or legacy users without the field) pass through
  if (!user || user.role === 'admin' || user.email_verified !== false) {
    return children;
  }

  const handleResend = async () => {
    setResending(true);
    try {
      const token = user.token || localStorage.getItem('token');
      await axios.post(`${API}/auth/resend-verification`, {}, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true
      });
      setResent(true);
    } catch (e) {
      // Silently handle
    }
    setResending(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="flex items-center justify-center gap-2 mb-8">
          <Shield className="w-6 h-6 text-[#FF3B30]" />
          <span className="font-heading text-white font-bold text-xl tracking-tight">RiskCoach<span className="text-[#FF3B30]">.ai</span></span>
        </div>
        <div className="bg-[#141414] border border-[#262626] rounded-sm p-8">
          <div className="w-12 h-12 bg-[#FF3B30]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Mail className="w-6 h-6 text-[#FF3B30]" />
          </div>
          <h2 data-testid="verify-gate-heading" className="text-white font-bold text-xl mb-2">Check Your Email</h2>
          <p className="text-[#A3A3A3] text-sm mb-2">We sent a verification link to:</p>
          <p className="text-white font-medium text-sm mb-6">{user.email}</p>
          <p className="text-[#737373] text-xs mb-6">Click the link in the email to activate your account. Check your spam folder if you don't see it.</p>
          <div className="space-y-3">
            <button
              data-testid="resend-verification-button"
              onClick={handleResend}
              disabled={resending || resent}
              className="w-full border border-[#262626] hover:border-white disabled:opacity-50 text-white font-medium py-2.5 rounded-sm transition-colors flex items-center justify-center gap-2 text-sm"
            >
              <RefreshCw className={`w-4 h-4 ${resending ? 'animate-spin' : ''}`} />
              {resent ? 'Verification Email Resent' : resending ? 'Sending...' : 'Resend Verification Email'}
            </button>
            <button
              data-testid="verify-gate-logout"
              onClick={logout}
              className="w-full text-[#737373] hover:text-white text-sm transition-colors py-2"
            >
              Sign out and use a different email
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
